"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * keepkey-sdk-server
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecoverDeviceRequestToJSON = exports.RecoverDeviceRequestFromJSONTyped = exports.RecoverDeviceRequestFromJSON = exports.instanceOfRecoverDeviceRequest = exports.RecoverDeviceRequestWordCountEnum = void 0;
const runtime_1 = require("../runtime");
const RecoverDeviceRequestAutoLockDelayMs_1 = require("./RecoverDeviceRequestAutoLockDelayMs");
const TypesNumericU32_1 = require("./TypesNumericU32");
/**
 * @export
 */
exports.RecoverDeviceRequestWordCountEnum = {
    NUMBER_12: 12,
    NUMBER_18: 18,
    NUMBER_24: 24
};
/**
 * Check if a given object implements the RecoverDeviceRequest interface.
 */
function instanceOfRecoverDeviceRequest(value) {
    let isInstance = true;
    isInstance = isInstance && "word_count" in value;
    return isInstance;
}
exports.instanceOfRecoverDeviceRequest = instanceOfRecoverDeviceRequest;
function RecoverDeviceRequestFromJSON(json) {
    return RecoverDeviceRequestFromJSONTyped(json, false);
}
exports.RecoverDeviceRequestFromJSON = RecoverDeviceRequestFromJSON;
function RecoverDeviceRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'dry_run': !(0, runtime_1.exists)(json, 'dry_run') ? undefined : json['dry_run'],
        'u2f_counter': !(0, runtime_1.exists)(json, 'u2f_counter') ? undefined : (0, TypesNumericU32_1.TypesNumericU32FromJSON)(json['u2f_counter']),
        'auto_lock_delay_ms': !(0, runtime_1.exists)(json, 'auto_lock_delay_ms') ? undefined : (0, RecoverDeviceRequestAutoLockDelayMs_1.RecoverDeviceRequestAutoLockDelayMsFromJSON)(json['auto_lock_delay_ms']),
        'no_enforce_wordlist': !(0, runtime_1.exists)(json, 'no_enforce_wordlist') ? undefined : json['no_enforce_wordlist'],
        'label': !(0, runtime_1.exists)(json, 'label') ? undefined : json['label'],
        'language': !(0, runtime_1.exists)(json, 'language') ? undefined : json['language'],
        'pin_protection': !(0, runtime_1.exists)(json, 'pin_protection') ? undefined : json['pin_protection'],
        'passphrase_protection': !(0, runtime_1.exists)(json, 'passphrase_protection') ? undefined : json['passphrase_protection'],
        'word_count': json['word_count'],
    };
}
exports.RecoverDeviceRequestFromJSONTyped = RecoverDeviceRequestFromJSONTyped;
function RecoverDeviceRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'dry_run': value.dry_run,
        'u2f_counter': (0, TypesNumericU32_1.TypesNumericU32ToJSON)(value.u2f_counter),
        'auto_lock_delay_ms': (0, RecoverDeviceRequestAutoLockDelayMs_1.RecoverDeviceRequestAutoLockDelayMsToJSON)(value.auto_lock_delay_ms),
        'no_enforce_wordlist': value.no_enforce_wordlist,
        'label': value.label,
        'language': value.language,
        'pin_protection': value.pin_protection,
        'passphrase_protection': value.passphrase_protection,
        'word_count': value.word_count,
    };
}
exports.RecoverDeviceRequestToJSON = RecoverDeviceRequestToJSON;
